var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.content !== null)?_c('list',_vm._g(_vm._b({ref:"list",staticClass:"px-4"},'list',_vm.list,false),_vm.onList)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }